import React from 'react';
import CreativeSolutionWebsite from './CreativeSolutionWebsite';

function App() {
  return <CreativeSolutionWebsite />;
}

export default App;
